import { useState } from "react";
import { X, Loader2 } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

import RichTextEditor from "@/components/RichTextEditor";
const TYPES = ["volunteer", "paid", "donation", "trade"];

export default function StewardshipFormModal({ item, onClose, onSaved }) {
  const editing = !!item?.id;
  const [f, setF] = useState({
    title: item?.title || "", description: item?.description || "", opportunity_type: item?.opportunity_type || "volunteer",
    category: item?.category || "Stewardship", location: item?.location || "", commitment: item?.commitment || "",
    compensation: item?.compensation || "", spots: item?.spots || 0, contact_email: item?.contact_email || "", image: item?.image || "",
  });
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === "number" ? (parseInt(e.target.value) || 0) : e.target.value });

  const save = async (e) => {
    e.preventDefault();
    if (!f.title.trim()) return toast.error("Please add a title so people know what this is.");
    setSaving(true);
    try {
      if (editing) await api.put(`/enhancer/stewardship/opportunities/${item.id}`, f);
      else await api.post("/enhancer/stewardship/opportunities", f);
      toast.success("Submitted for approval");
      onSaved(); onClose();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail) || err.message); }
    finally { setSaving(false); }
  };

  return (
    <div className="fixed inset-0 z-[100] grid place-items-center bg-black/40 backdrop-blur-sm p-4 overflow-y-auto py-10" data-testid="steward-form-modal">
      <div className="relative w-full max-w-lg bg-[#F9F7F3] rounded-3xl shadow-2xl p-8 my-auto">
        <button onClick={onClose} className="absolute top-4 right-4 text-[#4A5D6B] hover:text-[#144F75]"><X size={20} /></button>
        <h3 className="font-serif text-2xl text-[#1A242B] mb-1">{editing ? "Edit" : "Propose"} stewardship</h3>
        <p className="text-sm text-[#4A5D6B] mb-4">Submit an event or program. It goes to the EYW team for approval before publishing.</p>
        <form onSubmit={save} className="space-y-3">
          <input required placeholder="Title" value={f.title} onChange={set("title")} data-testid="steward-title" className="eyw-input w-full" />
          <RichTextEditor value={f.description} onChange={(v) => setF((x) => ({ ...x, description: v }))} testid="steward-desc" placeholder="Description" minHeight={110} enableBlocks={false} media={false} />
          <div className="grid grid-cols-2 gap-3">
            <select value={f.opportunity_type} onChange={set("opportunity_type")} data-testid="steward-type" className="eyw-input w-full capitalize">{TYPES.map((t) => <option key={t} value={t}>{t}</option>)}</select>
            <input placeholder="Category" value={f.category} onChange={set("category")} className="eyw-input w-full" />
            <input placeholder="Location" value={f.location} onChange={set("location")} className="eyw-input w-full" />
            <input placeholder="Commitment (e.g. 2 hrs)" value={f.commitment} onChange={set("commitment")} className="eyw-input w-full" />
            <input placeholder="Compensation / Trade" value={f.compensation} onChange={set("compensation")} className="eyw-input w-full" />
            <input type="number" placeholder="Spots (0=∞)" value={f.spots} onChange={set("spots")} className="eyw-input w-full" />
          </div>
          <input placeholder="Contact email" value={f.contact_email} onChange={set("contact_email")} className="eyw-input w-full" />
          <button type="submit" disabled={saving} data-testid="steward-save" className="eyw-btn w-full disabled:opacity-60">{saving && <Loader2 className="animate-spin" size={18} />} Submit for approval</button>
        </form>
      </div>
    </div>
  );
}
